import React from "react";
import classNames from "classnames";

import { apiPath } from "shared/helpers/apiPath";
import useRequest from "@/helpers/useRequest";
import PodcastCard from "@/components/PodcastCard";
import SectionHeading from "@/components/SectionHeading";
import { SimilarPodcastInterface } from "@/components/SimilarPodcasts/SimilarPodcast.interface";

import styles from "./SimilarPodcasts.module.scss";

export const SimilarPodcasts: React.FC<SimilarPodcastInterface> = ({
  slug,
  isMobile,
}) => {
  const { data } = useRequest(apiPath.SIMILAR_PODCASTS(slug));

  const podcasts =
    data && data.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

  return !!podcasts?.length ? (
    <div className={classNames(isMobile ? "hide-on-xl" : "show-on-xl")}>
      <SectionHeading
        title="Podobne podcasty"
        className={classNames(styles.heading, isMobile && styles.mobile)}
      />

      <div className={classNames(styles.section, isMobile && styles.mobile)}>
        <div className={styles.list}>
          {podcasts.map((podcast) => (
            <PodcastCard
              key={podcast.slug}
              {...podcast}
              picture={podcast.artwork}
              size="small"
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default SimilarPodcasts;
